<template>
    <div>
        <c-panel>
            <el-form label-position="top">
                <el-row :gutter="10">                    
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="loadingVagas()" type="primary">ATUALIZAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Curso</th>
                            <th style="width: 80px;">Vagas</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in items" :key="i">
                            <td :class="{fundoAmarelo: item < 50 ? true: false, fundoVermelho: item < 20 ? true : false }">{{ i }}</td>
                            <td :class="{fundoAmarelo: item < 50 ? true: false, fundoVermelho: item < 20 ? true : false }">{{ item }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>
        </c-panel>

    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: true,        
        items: [ ]      
    }),
    mounted () {
        this.loadingVagas();
    },
    methods: {
        loadingVagas(){
           
            this.statusList = false;
            this.items = [];

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/vagas/getVagasDeTodasInstituicoesPorCurso`, 
                this.$store.getters.getHeaderAuth).then(response => {
        
                this.items = response.data;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });           
        }
    },    
}
</script>

<style scoped>
.fundoAmarelo{
    background-color: #feffe7 !important;
}
.fundoVermelho{
    background-color: #ffd2d2 !important;
}
</style>